import { Button, Col, Form, Input, message, Modal, Row, Select } from "antd"
import TextArea from "antd/lib/input/TextArea"
import { toISOFormat, validarData } from "../../../utils/date"
import { ruleDataInvalida } from "../../../utils/custom-rules-antd"
import { EPeriodoNome } from "../../../components/enums/periodo.enum"
import { useEffect, useState } from "react"
import { municipioService } from "../../../services/Municipios-Service/municipios-service"
import MaskedInput  from 'react-input-mask';
import api from "../../../services/api"
import { bloqueioService } from "../../../services/Bloqueio-Service/bloqueio-service"
import { loginService } from "../../../services/Login-Service/login-service"

interface ModalEditarBloqueioProps{
    visible: boolean
    setVisible: Function
    onClose: Function
    info: any
}

const ModalEditarBloqueio = (props:ModalEditarBloqueioProps) =>{

    const [form] = Form.useForm()
    const [municipios, setMunicipios] = useState<any>();


    useEffect(()=>{
        
        municipioService.getMunicipio().then((resp)=>{
            setMunicipios(resp.data)
        })
        if (props.info != null) {
            form.setFieldsValue({
                bloqueioID: props.info.bloqueioID,
                nome: props.info.nome,
                descricao: props.info.descricao,
                dataBloqueio: props.info.dataBloqueio,
                periodo: props.info.periodo,
                municipioID: props.info.municipioID,
            });
        }
    }, [props.info])

    const onFinish = (values:any) =>{
        values.dataBloqueio = toISOFormat(values.dataBloqueio)
        bloqueioService.put({
            BloqueioID: props.info.bloqueioID,
            Nome: values.nome,
            Descricao: values.descricao,
            DataBloqueio: values.dataBloqueio,
            Periodo: values.periodo,
            MunicipioID: values.municipioID,
            Ativo: true
        }
        )
        .finally(()=> {
        })
        .then((response) => {
            if (response.data.valido) {
                props.setVisible(false);
                props.onClose();
                message.success('Bloqueio salvo com sucesso')
            }
            else {
                message.error(response.data.error,10)               
            }
        })
        .catch((err) => {
            message.error('Falha na requisição')              
        });
    }

    return (
        <>
        <Modal
            visible={props.visible}
            title="Novo Bloqueio"
            onCancel={()=> {props.setVisible(false)}}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um nome!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Bloqueio" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Descrição"
                            name="descricao"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira a descrição!',
                                }
                            ]}

                        >
                            <TextArea placeholder="DIGITE A DESCRIÇÃO" rows={4}></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Data"
                            name="dataBloqueio"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira a data!',
                                    validator: ruleDataInvalida
                                }
                            ]}
                        >
                            <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={12}>
                        <Form.Item
                            label="Período"
                            name="periodo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select placeholder="Período">
                                {EPeriodoNome.map((item:any, index:number)=>
                                    <Select.Option key={index} value={item.key}> {item.description}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Município"
                            name="municipioID"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor selecione!',
                                }
                            ]}
                        >
                            <Select placeholder="Informe o município do feriado">
                                {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <Select.Option value={municipios?.municipioID}>{municipios?.nome}</Select.Option>                                 
                                :
                                 municipios?.map((value:any, index:number)=>
                                    <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>

                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
        </>
    )
}

export default ModalEditarBloqueio